/** Alinhado a docs/contracts/api/response-envelope/standard.md */
export interface ApiErrorItem {
  code: string;
  messageKey: string;
}

export interface ApiEnvelope<T> {
  success: boolean;
  data: T | null;
  errors: ApiErrorItem[];
}

/** Extrai `data` em sucesso; caso contrário lança com `messageKey` do primeiro erro. */
export function unwrapApiEnvelope<T>(envelope: ApiEnvelope<T>): T {
  if (!envelope.success || envelope.data == null) {
    const messageKey = envelope.errors[0]?.messageKey ?? 'app.common.errors.unexpected';
    throw new Error(messageKey);
  }

  return envelope.data;
}
